<template>
  <v-container fluid>
    <div class="d-flex flex-column justify-center align-center mt-12">
        <v-card flat
             class="col-12 col-md-6 rounded-lg ma-5">
          <v-card-text>
              <p>{{ $t('paragraphs.index.welcome1') }}</p>             
              <p>{{ $t('paragraphs.index.welcome2') }}</p>
              <p>{{ $t('paragraphs.index.welcome3') }}</p>
          </v-card-text>
        </v-card>
        <v-card
            flat
            class="col-12 col-md-6 rounded-lg"
        >
          <v-card-title class="justify-center">
            {{ $t('cards.titles.login') }}
          </v-card-title>
          <v-divider></v-divider>
          <v-form
            @submit.prevent="continueSignIn()"
          >
            <v-card-text>
              <v-text-field
                  v-model="form.email"
                  :label="$t('labels.email')"
              ></v-text-field>

            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn
                  class="rounded-lg"
                  color="primary"
                  :disabled="!form.email"
                  @click.prevent="continueSignIn()"
                  :loading="isLoading"
              >
                {{ $t('buttons.continue') }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
    </div>
  </v-container>

</template>

<script>
import api from "@/api/api";

export default {
  name: "m2h-login",
  props: ['next'],
  components: {
  },
  data() {
    return {
      isLoading: false,
      form: {
        email: ''
      }
    }
  },
  mounted() {

  },
  methods: {
    async continueSignIn () {
      if (this.form.email){
        const that = this
        that.isLoading = true
        let res = await api.login.getUrl(that.form.email, this.next)
        window.location = res.data 
        that.isLoading = false
      }
    },
  }
}
</script>

<style scoped>

</style>